// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Image2 from "../../assets/image/stripe.png";
import Image from "../../assets/image/brown.png";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getAllCard, removeCard, userPayment } from "../../services/cardsFn";
import { useAuth } from "../../context/AuthContext";
import AppLoader from "../loader/loader";
import { useSubscription } from "../../context/SubscriptionContext";

function Payment() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [cards, setCards] = useState(null);
  const { userId, user } = useAuth();
  const { selectedPackage: pkg } = useSubscription();
  const showAlert = (title, text, icon) => {
    Swal.fire({
      title,
      text,
      icon,
      confirmButtonText: "OK",
    });
  };

  useEffect(() => {
    fetchCards();
  }, []);

  const fetchCards = async () => {
    setIsLoading(true);
    try {
      const response = await getAllCard(userId._id);
      if (response.data.status === "success") {
        setCards(response.data.data[0]);
      }
    } catch (error) {
      console.error("Error fetching cards:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const cardRemove = async () => {
    const payload = {
      userId: userId._id,
      paymentId: cards?.id,
    };

    setIsLoading(true);
    try {
      const response = await removeCard(payload);

      if (response.status === 200 || response.status === 201) {
        showAlert("Success", response.data.message, "success");
      } else {
        showAlert("Error", response.data.message, "error");
      }
    } catch (error) {
      showAlert(
        "Error",
        "Error removing card: " + (error?.message || "Unknown error"),
        "error"
      );
    } finally {
      setIsLoading(false);
      fetchCards();
    }
  };

  // const userProceedPayment = async () => {
  //   setIsLoading(true);
  //   const payload = {
  //     userId: user._id,
  //     paymentId: cards?.id,
  //     amount: pkg?.price,
  //     subscriptionId: pkg?._id,
  //   };
  //   const response = await userPayment(payload);
  //   if (response.data.status === "success") {
  //     navigate("/login-inner");
  //     showSuccessAlert(response);
  //   }
  //   setIsLoading(false);
  // };
  const handlenavigateBack = () => {
    navigate(-1);
  };

  const showSuccessAlert = (response) => {
    Swal.fire({
      title: "Success!",
      text: response.data.message,
      icon: "success",
      confirmButtonText: "OK",
    });
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <section className="payment-plan-section">
        <div className="payment-hero">
          <div className="container box-con">
            <div className="payment-box">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-4 col-md-4 col-sm-4 arrow-icon">
                  <div className="icon-times" onClick={handlenavigateBack}>
                    <FontAwesomeIcon
                      icon={faArrowLeft}
                      className="sub-icon-times"
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 top-heading-py">
                  <h2>Payment</h2>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-4 info-img">
                  {/* <div className="icon-times2">
                    <img src={Image} alt="icon" />
                  </div> */}
                </div>
              </div>
              <div className="row st-h">
                <div className="col-md-10 col-sm-6 py-col">
                  <h6>Payment Methods</h6>
                </div>
                <div className="col-md-2 col-sm-6 img-col">
                  <img src={Image2} alt="Stripe Icon" />
                </div>
              </div>

              {/* Display Cards */}
              {/* <div className="card-list">
                {cards?.length > 0 ? (
                  cards?.map((card) => (
                    <div key={card.id} className="strip-card">
                      <img
                        src={Image2}
                        alt="Stripe Icon"
                        className="card-image"
                      />
                      <div className=" sub-total">
                        <p>
                          {card.card.brand} <br />
                          **** **** **** {card.card.last4}
                        </p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No cards available. Please add a card.</p>
                )}
              </div> */}

              <div className="card-container">
                {cards ? (
                  <>
                    <div key={cards.id} className="strip-card">
                      <img
                        src={Image2}
                        alt="Stripe Icon"
                        className="card-image"
                      />
                      <div className="sub-total">
                        <p>
                          {cards.card.brand} <br />
                          **** **** **** {cards.card.last4}
                        </p>
                      </div>
                    </div>
                    <button
                      className="btn-card remove-card"
                      onClick={cardRemove}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-dash-circle"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M3 8a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8A.5.5 0 0 1 3 8z" />
                      </svg>
                      Remove Stripe Card
                    </button>
                  </>
                ) : (
                  <>
                    {/* Message when no cards are available */}
                    <p>No cards available. Please add a card.</p>

                    {/* Add Stripe Card Button */}
                    <button
                      className="btn-card"
                      onClick={() => navigate("/stripe")}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-plus-circle"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                      </svg>
                      Add Stripe Card
                    </button>
                  </>
                )}
              </div>

              {/* <button className="btn-card" onClick={() => navigate("/stripe")}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-plus-circle"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                </svg>
                Add Stripe Card
              </button> */}
              <h3 className="total-py">Total Payable Amount</h3>
              <hr />
              <div className="row">
                <div className="col-md-6 col-6 sub-total">
                  <p>Subtotal</p>
                </div>
                <div className="col-md-6 col-6 sub-price">
                  <p>$ {pkg?.price || "0.00"}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 col-6 sub-total">
                  <p>Tax</p>
                </div>
                <div className="col-md-6 col-6 sub-price">
                  <p>$ 0.00</p>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col-md-6 col-6 sub-total">
                  <p>Total Amount</p>
                </div>
                <div className="col-md-6 col-6 sub-price">
                  <p>$ {pkg?.price || "0.00"}</p>
                </div>
              </div>
              <button
                className="btn-1"
                onClick={() => navigate("/payment-confirm")}
                disabled={!cards}
                style={{
                  opacity: !cards ? 0.6 : 1,
                  cursor: !cards ? "not-allowed" : "pointer",
                }}
              >
                Proceed to Pay
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Payment;
